export default __webpack_public_path__ + "static/media/bgIcon.524f4647.svg";